<template>

  <div id="como-funciona">

    <section class="d-flex align-items-center como-funciona">

        <div class="container">

          <div class="section-title" data-aos="fade-up">
            <div class="row">
              <h1 data-aos="fade-up">Entenda como funciona nossa integração</h1>
              <h5 class="mb-5" data-aos="fade-up" data-aos-delay="400">Veja como é simples utilizar nossa plataforma para você ganhar mais tempo crescendo seu negócio.</h5>
            </div>

            <div class="row">
              <div class="col-md-6 d-flex align-items-stretch mb-4 gap-5" data-aos="fade-left" data-aos-delay="300">
                <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
                  <div class="icon-number">1</div>
                  <h4 class="title"><strong>Você pluga sua plataforma de pagamento</strong></h4>
                  <p class="description">De forma simples e rápida você adiciona integração com as plataformas que você utiliza para vender seus infoprodutos.</p>
                  <div class="image d-flex justify-content-center" data-aos="fade-right" data-aos-delay="150">
                    <img src="../assets/img/integracao-sigame-1.png" alt="" class="img-fluid" style="width: 280px;">
                  </div>
                </div>
              </div>
              <div class="col-md-6 d-flex align-items-stretch mb-4" data-aos="fade-left" data-aos-delay="300">
                <div class="icon-box justify-content-center" data-aos="fade-up" data-aos-delay="200">
                  <div class="icon-number">2</div>
                  <h4 class="title"><strong>Você escolhe quando devemos emitir suas notas fiscais</strong></h4>
                  <p class="description">Conforme o seu agendamento na plataforma de pagamento suas notas fiscais serão emitidas na confirmação do pagamento ou na garantia.</p>
                  <div class="image d-flex justify-content-center" data-aos="fade-right" data-aos-delay="150">
                    <img src="../assets/img/integracao-sigame-2.png" alt="" class="img-fluid" style="width: 280px;">
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 d-flex align-items-stretch mb-4 gap-4" data-aos="fade-left" data-aos-delay="300">
                <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
                  <div class="icon-number">3</div>
                  <h4 class="title"><strong>Nós emitimos suas notas e as encaminhamos aos seus clientes</strong></h4>
                  <p class="description">Na competência programada, emitimos as notas fiscais, encaminhamos aos clientes e notificamos o webhook da sua plataforma de pagamento.</p>
                  <div class="image d-flex justify-content-center" data-aos="fade-right" data-aos-delay="150">
                    <img src="../assets/img/integracao-sigame-3.png" alt="" class="img-fluid" style="width: 280px;">
                  </div>
                </div>
              </div>
              <div class="col-md-6 d-flex align-items-stretch mb-4 gap-4" data-aos="fade-left" data-aos-delay="300">
                <div class="icon-box justify-content-center" data-aos="fade-up" data-aos-delay="200">
                  <div class="icon-number">4</div>
                  <h4 class="title"><strong>Você ganha mais tempo para focar no seu negócio</strong></h4>
                  <p class="description">Pronto, agora você tem uma solução robusta, otimizada e totalmente em nuvem para escalar a rotina diária de emissão de NFS-e para seu negócio.
                  </p>
                  <div class="image d-flex justify-content-center" data-aos="fade-right" data-aos-delay="150">
                    <img src="../assets/img/integracao-sigame-4.png" alt="" class="img-fluid" style="width: 280px;">
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>

    </section>

  </div>

</template>

<script>
export default {
  name: 'ComoComp'
}
</script>

<style scoped lang="scss">
.como-funciona{
  background-color: $como-funciona-bg-color;
  padding-top: 0;
  padding: 5vh 1vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.como-funciona .icon-box {
  padding: 30px;
  position: relative;
  overflow: hidden;
  background: $bg-base;
  box-shadow: 0 0 29px 0 rgba(68, 88, 144, 0.12);
  box-shadow: $como-funciona-icon-box-box-shadow;
  transition: box-shadow 0.3s ease;
  border-radius: 8px; /* 40px; */
  z-index: 1;
}

.como-funciona .icon-number {
  font-family: $font-family-base;
  font-weight: 700;
  font-size: 28px;
  margin: 0 auto 20px auto;
  padding-top: 6px;
  display: inline-block;
  text-align: center;
  letter-spacing: 1px;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  transition: 0.5s;
  color: $btn-default-color;
  background: $btn-default-bg;
  border: 2px solid $btn-default-bg;
}

.como-funciona .icon-number:hover {
  transition: box-shadow 0.3s ease;
  box-shadow: 0px 0px 0px 7px $como-funciona-icon-number-hover;
}

.como-funciona .icon i {
  font-size: 36px;
  line-height: 1;
  color: $bg-base;
}

.como-funciona .title {
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 18px;
}

.como-funciona .description {
  font-size: 15px;
  line-height: 28px;
  margin-bottom: 0;
}

@media (max-width: 1024px) {
  .como-funciona.image {
    text-align: center;
  }

  .como-funciona.image img {
    max-width: 70%;
  }
}

@media (max-width: 667px) {
  .como-funciona.image img {
    max-width: 100%;
  }
}
</style>
